// // src/components/FileUpload.tsx
// import React, { useState } from "react";
// import { FileUploadService } from "../../api";
// import { Body_upload_file_docrepo_upload_post } from "../../api/models/Body_upload_file_docrepo_upload_post";

// interface FileUploadProps {
//   collection_type: string;        // Service Requests
//   collection_ref: string;     // Srvice Request ID
//   repo_type: string;      // RESUME, JD, REPORTS
//   multiple?: boolean;      // allow multiple uploads
//   role: "Admin" | "User";  // enforce valid roles
//   label: string;           // section label
//   files: string[];         // list of file URLs
//   onChange: (newFiles: string[]) => void; // callback to update parent state
// }

// const FileUpload: React.FC<FileUploadProps> = ({
//   collection_type,
//   collection_ref,
//   repo_type,
//   role,
//   label,
//   multiple = false,
//   files,
//   onChange,
// }) => {
//   const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
//   const [previewUrl, setPreviewUrl] = useState<string | null>(null);

//   const handleSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
//     if (e.target.files) {
//       setSelectedFiles(Array.from(e.target.files));
//     }
//   };
//   const uploadMode = "final"; // Multiple File Uploads allowed only in final mode
//   const handleUpload = async () => {
//     if (!selectedFiles.length) return;
//     const body: Body_upload_file_docrepo_upload_post = { files: selectedFiles };
//     const res = await FileUploadService.uploadFileDocrepoUploadPost(
//       collection_type,
//       collection_ref,
//       repo_type,
//       body,
//       uploadMode,
//     );
//     const urls = res.data?.uploaded ?? [];
//     onChange(multiple ? [...files, ...urls] : urls);
//     setSelectedFiles([]);
//   };

//   const handleRemove = async (url: string) => {
//     await FileUploadService.deleteFileDocrepoDeleteDelete(
//       url,
//       collection_type,
//       collection_ref,
//       repo_type
//     );
//     onChange(files.filter((f) => f !== url));
//   };

//   const handleView = async (url: string) => {
//     const res = await FileUploadService.getFileDocrepoViewCollectionTypeCollectionRefRepoTypeFilenameGet(
//       collection_type,
//       collection_ref,
//       repo_type,
//       url.split("/").pop()!
//     );
//     const blob = new Blob([res.data], { type: "application/pdf" });
//     setPreviewUrl(URL.createObjectURL(blob));
//   };

//   return (
//     <div className="mt-6">
//       {/* <h2 className="text-lg font-semibold mb-2">{label}</h2> */}

//       {/* Upload controls */}
//       {role === "Admin" ? (
//         <div className="flex items-center space-x-2 mb-4">
//           <input type="file" multiple={multiple} onChange={handleSelect} />
//           <button
//             onClick={handleUpload}
//             disabled={!selectedFiles.length}
//             className="bg-green-600 text-white px-3 py-1 rounded hover:bg-green-700 disabled:opacity-50"
//           >
//             Upload {label}
//           </button>
//         </div>
//       ) : (
//         <div className="mb-4">
//           {files.length ? (
//             <p>You have already uploaded your {label.toLowerCase()}.</p>
//           ) : (
//             <p>Please upload your {label.toLowerCase()}.</p>
//           )}
//           <div className="flex items-center space-x-2 mt-2">
//             <input type="file" multiple={multiple} onChange={handleSelect} />
//             <button
//               onClick={handleUpload}
//               disabled={!selectedFiles.length}
//               className="bg-green-600 text-white px-3 py-1 rounded hover:bg-green-700 disabled:opacity-50"
//             >
//               Upload {label}
//             </button>
//           </div>
//         </div>
//       )}

//       {/* File list */}
//       {files.length > 0 && (
//         <ul className="space-y-2">
//           {files.map((url, idx) => (
//             <li key={idx} className="flex items-center space-x-2">
//               <span className="flex-1">{url.split("/").pop()}</span>
//               <button
//                 onClick={() => handleView(url)}
//                 className="bg-blue-600 text-white px-3 py-1 rounded hover:bg-blue-700"
//               >
//                 View
//               </button>
//               {role === "Admin" && (
//                 <button
//                   onClick={() => handleRemove(url)}
//                   className="bg-red-600 text-white px-3 py-1 rounded hover:bg-red-700"
//                 >
//                   Remove
//                 </button>
//               )}
//             </li>
//           ))}
//         </ul>
//       )}

//       {/* Preview modal */}
//       {previewUrl && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//           <div className="bg-white rounded-lg shadow-lg w-11/12 h-5/6 relative">
//             <button
//               onClick={() => setPreviewUrl(null)}
//               className="absolute top-2 right-2 bg-red-600 text-white px-3 py-1 rounded hover:bg-red-700"
//             >
//               Close
//             </button>
//             <iframe src={previewUrl} title="Preview" className="w-full h-[600px]" />
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

import React, { useState, useEffect } from "react";
import { FileUploadService } from "../../api";
import { Body_upload_file_docrepo_upload_post } from "../../api/models/Body_upload_file_docrepo_upload_post";

interface FileUploadProps {
  collection_type: string;
  collection_ref: string;
  repo_type: string;
  multiple?: boolean;
  role: "Admin" | "User";
  label: string;
  files: string[];
  onChange: (newFiles: string[]) => void;
  onRefresh?: () => void;
}

const FileUpload: React.FC<FileUploadProps> = ({
  collection_type,
  collection_ref,
  repo_type,
  role,
  label,
  multiple = false,
  files,
  onChange,
  onRefresh,
}) => {
  const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  /* ================= SELECT ================= */
  const handleSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files) return;
    setSelectedFiles(Array.from(e.target.files));
  };

  /* ================= UPLOAD ================= */
  const handleUpload = async () => {
    if (!selectedFiles.length) return;

    try {
      setLoading(true);

      const body: Body_upload_file_docrepo_upload_post = {
        files: selectedFiles,
      };

      const res = await FileUploadService.uploadFileDocrepoUploadPost(
        collection_type,
        collection_ref,
        repo_type,
        body,
        "final"
      );

      const uploadedFiles =
        res?.uploaded ??
        res?.data?.uploaded ??
        [];

      const urls = uploadedFiles
        .map((f: any) => f.url)
        .filter(Boolean);

      onChange(multiple ? [...files, ...urls] : urls);
      onRefresh?.();

      setSelectedFiles([]);
    } catch (err) {
      console.error("Upload failed", err);
    } finally {
      setLoading(false);
    }
  };

  /* ================= DELETE ================= */
  const handleRemove = async (url: string) => {
    try {
      await FileUploadService.deleteFileDocrepoDeleteDelete(
        url,
        collection_type,
        collection_ref,
        repo_type
      );

      onChange(files.filter((f) => f !== url));
      onRefresh?.();
    } catch (err) {
      console.error("Delete failed", err);
    }
  };

  /* ================= VIEW ================= */
  const handleView = async (url: string) => {
    try {
      const res =
        await FileUploadService.getFileDocrepoViewCollectionTypeCollectionRefRepoTypeFilenameGet(
          collection_type,
          collection_ref,
          repo_type,
          url.split("/").pop()!
        );

      const blob = new Blob([res.data], { type: "application/pdf" });
      const objectUrl = URL.createObjectURL(blob);

      setPreviewUrl(objectUrl);
    } catch (err) {
      console.error("Preview failed", err);
    }
  };

  /* ================= CLEANUP ================= */
  useEffect(() => {
    return () => {
      if (previewUrl) URL.revokeObjectURL(previewUrl);
    };
  }, [previewUrl]);

  return (
    <div className="mt-6 space-y-3">

      {/* UPLOAD */}
      <div className="flex items-center gap-2">
        <input type="file" multiple={multiple} onChange={handleSelect} />

        <button
          onClick={handleUpload}
          disabled={!selectedFiles.length || loading}
          className="bg-green-600 text-white px-3 py-1 rounded disabled:opacity-50"
        >
          {loading ? "Uploading..." : `Upload ${label}`}
        </button>
      </div>

      {/* FILE LIST */}
      {files.length > 0 ? (
        <ul className="space-y-2">
          {files.map((url) => (
            <li
              key={url}
              className="flex items-center gap-2 border p-2 rounded"
            >
              <span className="flex-1 truncate">
                {url.split("/").pop()}
              </span>

              <button
                onClick={() => handleView(url)}
                className="text-blue-600"
              >
                View
              </button>

              {role === "Admin" && (
                <button
                  onClick={() => handleRemove(url)}
                  className="text-red-600"
                >
                  Remove
                </button>
              )}
            </li>
          ))}
        </ul>
      ) : (
        <p className="text-sm text-gray-500">
          No {label.toLowerCase()} uploaded yet
        </p>
      )}

      {/* PREVIEW */}
      {previewUrl && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-white w-11/12 h-5/6 relative rounded">
            <button
              onClick={() => setPreviewUrl(null)}
              className="absolute top-2 right-2 bg-red-600 text-white px-3 py-1 rounded"
            >
              Close
            </button>

            <iframe src={previewUrl} className="w-full h-full" />
          </div>
        </div>
      )}
    </div>
  );
};

export default FileUpload;